
import React from 'react';
import styles from './backgroundOverlay.module.css'; // External CSS for styling

//I think similar to the below code we can optimise the calendar grid system so that the grids doesn't re-render every time the sessions refreshes.
const BackgroundOverlay = ({ children }) => {
  return (
    <div className={styles.overlay}>
      {children} {/* This renders whatever is passed between <BackgroundOverlay></BackgroundOverlay> */}
    </div>
  );
};

export default BackgroundOverlay;